import { atom } from 'jotai';
import {
  NUMBER_OF_QUESTIONS_PER_SECTION,
  NUMBER_OF_QUESTIONS_IN_WELCOME_PAGE,
  QUESTIONS_SECTIONS,
  getRandomisedQuestions
} from '../utils';
import { sample } from 'lodash';

export const questionsAtom = atom(getRandomisedQuestions(QUESTIONS_SECTIONS, NUMBER_OF_QUESTIONS_PER_SECTION));

export const questionsInWelcomePageAtom = atom(getRandomisedQuestions(QUESTIONS_SECTIONS, NUMBER_OF_QUESTIONS_IN_WELCOME_PAGE));

export const setQuestionForSubSectionAtom = atom(
  null,
  (get, set, currentSubSectionInfo: any) => {
    const {
      sectionIndex,
      clickedQuestionIndex,
    } = currentSubSectionInfo;
    // all questions shown currently
    const shownQuestions = [...get(questionsAtom)];

    // all questions for the section that was clicked
    const currentClickedSubSectionQuestions = shownQuestions[sectionIndex].questions;

    // the questions that were not shown for the section that was clicked
    const unshownQuestionsForClickedSubSection = QUESTIONS_SECTIONS[sectionIndex].questions.filter((el) => {
      return !currentClickedSubSectionQuestions.includes(el);
    });

    // pick a random question from the unshown questions
    const newQuestion = sample(unshownQuestionsForClickedSubSection);

    // replace the clicked question with the new question
    shownQuestions[sectionIndex].questions = 
      currentClickedSubSectionQuestions.filter((_el, idx) => idx !== clickedQuestionIndex).concat(newQuestion);

    set(questionsAtom, shownQuestions);
  }
);

export const chatFeedAtom = atom<{
  userMsg?: string,
  error?: object,
  timestamp?: number,
  // new version of response
  botData?: {
    type: string;
    text?: string;
    metricQueryInfo?: object;
    explanation?: object;
  }[]
}[]>([]);

export const lastChatAtom = atom((get) => {
  const chatList = get(chatFeedAtom);
  return chatList[chatList.length - 1] || {};
});

export const chatFeedWriteAtom = atom(
  null,
  (get, set, newChat: any, isNewChat?: boolean) => {
    let chatFeed = get(chatFeedAtom);

    chatFeed = [...chatFeed];

    if (isNewChat) {
      chatFeed.push({
        ...newChat
      });
    }
    else {
      chatFeed[chatFeed.length - 1] = {
        ...chatFeed[chatFeed.length - 1],
        ...newChat,
      };
    }

    set(chatFeedAtom, chatFeed);
  }
);